.trigger {
  cursor: var(--cursor-ds-interactive);
}

.trigger:disabled {
  cursor: var(--cursor-ds-disabled);
}
